import { useNotify } from "../../api/Notify";
import { mergeSampledValuesIntoSeries } from "./sampledValueSeries";

export const useChargingSse = (enabled, connectorPublicId, setSeriesData) => {
    useNotify(
        enabled ? [`transaction-meter-values:${connectorPublicId}`] : [],
        msg => {
            if (!enabled) return;

            const samples = msg?.data?.Data?.sampledValues ?? [];
            if (!Array.isArray(samples) || samples.length === 0) return;

            setSeriesData(prev => mergeSampledValuesIntoSeries(prev, samples));
        }
    );
};
